"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
const compact_1 = __importDefault(require("lodash/compact"));
const defaultKey = ['objective-traits'];
const keys = {
    default: defaultKey,
    objectiveOwnedTraits: (id, params) => {
        return (0, compact_1.default)([...defaultKey, 'owned', id, params]);
    },
    objectiveAssignedTraits: (id, params) => {
        return (0, compact_1.default)([...defaultKey, 'assigned', id, params]);
    }
};
exports.default = keys;
